import { render, staticRenderFns } from "./CustomerCommentCard.vue?vue&type=template&id=3544c6ec&scoped=true"
import script from "./CustomerCommentCard.vue?vue&type=script&lang=js"
export * from "./CustomerCommentCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerCommentCard.vue?vue&type=style&index=0&id=3544c6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544c6ec",
  null
  
)

export default component.exports